import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './routes/home';
import { CatchPage } from './routes/catch';
import { AuthCallback } from './routes/auth-callback';
import { WelcomePage } from './routes/welcome';
import { MyCatchesPage } from './routes/my-catches';
import { PrivacyPage } from './routes/privacy';
import { TermsPage } from './routes/terms';
import { MethodologyPage } from './routes/methodology';
import { AuthProviderRoot } from './auth/auth-provider';
import { RequireAuth } from './auth/require-auth';
import { NavHeader } from './components/nav-header';
import { Footer } from './components/footer';
import { FeatureFlagsProvider } from './lib/feature-flags';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProviderRoot>
          <FeatureFlagsProvider>
            <div className="flex min-h-dvh flex-col">
            <NavHeader />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/c/:id" element={<CatchPage />} />
                <Route path="/share/:id" element={<CatchPage />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/methodology" element={<MethodologyPage />} />
                <Route
                  path="/welcome"
                  element={
                    <RequireAuth>
                      <WelcomePage />
                    </RequireAuth>
                  }
                />
                <Route
                  path="/my-catches"
                  element={
                    <RequireAuth>
                      <MyCatchesPage />
                    </RequireAuth>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
          </FeatureFlagsProvider>
        </AuthProviderRoot>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

function NotFound() {
  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      <h1 className="text-3xl font-bold">404</h1>
      <p className="mt-2 text-muted-foreground">This catch isn't here.</p>
      <a href="/" className="mt-6 inline-block text-primary underline">
        Back to homepage
      </a>
    </div>
  );
}
